// extracted by mini-css-extract-plugin
module.exports = {"form":"NewContactModal_form__UuKvZ"};